import React from 'react';
import { IconCircle } from '@veneer/core';
import PropTypes from 'prop-types';

import {
  Container,
  Counter,
  StatusBadge,
  StatusCounterArea,
  StatusDescription,
  StatusIndicator,
} from './styles';

export const StatusListItem = ({
  color,
  dataTestId,
  display,
  id,
  filled,
  titleText,
  value,
}) => (
  <Container data-testid={`${dataTestId}-${id}-status-container`} display={display}>
    <StatusIndicator>
      <StatusBadge>
        <IconCircle
          data-testid={`${dataTestId}-${id}-icon`}
          size={14.36} //  12px = 10px in the UI as 14.36px = 12px in the UI
          filled={filled}
          color={color}
        />
      </StatusBadge>
      <StatusDescription data-testid={`${dataTestId}-${id}-description`}>
        {titleText}
      </StatusDescription>
    </StatusIndicator>
    <StatusCounterArea data-testid={`${dataTestId}-${id}-counter-area`}>
      <Counter className="label-regular" data-testid={`${dataTestId}-${id}-value`}>
        {value}
      </Counter>
    </StatusCounterArea>
  </Container>
);

StatusListItem.propTypes = {
  color: PropTypes.string,
  dataTestId: PropTypes.string,
  display: PropTypes.string,
  filled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  titleText: PropTypes.string.isRequired,
  value: PropTypes.number,
};

StatusListItem.defaultProps = {
  color: '#ffffff',
  display: 'flex',
  value: 0,
  filled: false,
  dataTestId: 'status-list-item',
};

export default StatusListItem;
